import { render, staticRenderFns } from "./NewAlertPersonalSet.vue?vue&type=template&id=de24e1c8&scoped=true"
import script from "./NewAlertPersonalSet.vue?vue&type=script&lang=js"
export * from "./NewAlertPersonalSet.vue?vue&type=script&lang=js"
import style0 from "./NewAlertPersonalSet.vue?vue&type=style&index=0&id=de24e1c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de24e1c8",
  null
  
)

export default component.exports